import React from 'react';

export interface JournalStickerOption {
  id: string;
  src: string;
  label: string;
}

const stickerPath = (filename: string) => `/journal_image/${filename}`;

export const JOURNAL_STICKERS: JournalStickerOption[] = [
  { id: 'sticker01', src: stickerPath('001.png'), label: '수줍' },
  { id: 'sticker02', src: stickerPath('002.png'), label: '우울' },
  { id: 'sticker04', src: stickerPath('003.png'), label: '신남' },
  { id: 'sticker05', src: stickerPath('004.png'), label: '설렘' },
  { id: 'sticker06', src: stickerPath('005.png'), label: '화남' },
  { id: 'sticker07', src: stickerPath('006.png'), label: '눈물' },
  { id: 'sticker08', src: stickerPath('007.png'), label: '지침' },
  { id: 'sticker10', src: stickerPath('008.png'), label: '행복' },
  { id: 'sticker11', src: stickerPath('009.png'), label: '궁금' },
];

export const DEFAULT_JOURNAL_STICKER = JOURNAL_STICKERS[0].id;

export const getJournalSticker = (value?: string | null) => {
  if (!value) return undefined;
  return JOURNAL_STICKERS.find(sticker =>
    sticker.id === value || sticker.src === value || sticker.src.endsWith(`/${value}`)
  );
};

export const normalizeJournalStickerId = (value?: string | null) =>
  getJournalSticker(value)?.id ?? DEFAULT_JOURNAL_STICKER;

interface JournalStickerProps {
  value?: string | null;
  size: number;
  className?: string;
}

export const JournalSticker: React.FC<JournalStickerProps> = ({ value, size, className }) => {
  const sticker = getJournalSticker(value) ?? JOURNAL_STICKERS[0];

  return (
    <img
      className={className}
      src={sticker.src}
      alt={sticker.label}
      width={size}
      height={size}
      draggable={false}
      style={{ display: 'block', objectFit: 'contain' }}
    />
  );
};
